export default "__VITE_ASSET__CCkZi1cu__"